import { Outlet } from 'react-router';
import { MarketingShell } from '#marketing/components/MarketingShell.jsx';

/**
 * Marketing layout for the static site build (no CSRF — contact uses Pages Function).
 */
export default function MarketingLayout() {
  return (
    <MarketingShell>
      <Outlet />
    </MarketingShell>
  );
}
